/**
 * Page Loading Spinner
 * Wrapper around PulseLoader for backward compatibility
 */

import { PulseLoader } from './PulseLoader';

interface PageLoadingSpinnerProps {
  message?: string;
}

/**
 * Consistent loading spinner for page-level data loading.
 * Use this inside Layout for data-fetching loading states.
 */
export function PageLoadingSpinner({ message }: PageLoadingSpinnerProps) {
  // Extract page name from message if it follows "Loading X..." pattern
  const pageNameMatch = message?.match(/^Loading (.+?)\.\.\.$/i);
  const pageName = pageNameMatch ? pageNameMatch[1] : undefined;

  return (
    <PulseLoader
      pageName={pageName}
      message={pageName ? undefined : message}
    />
  );
}
